export default "__VITE_ASSET__CSBa61co__"